var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticStyle:{"display":"inline-flex","align-items":"center"}},[_vm._v(_vm._s("\u200b")),_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }